import React from 'react';
import Slider from 'react-slick';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';
import { downloadFileSettings } from 'core/config/slides';

const UpcomingProductV1 = ({ slideSections }) => {
	const img_api = process.env.REACT_APP_IMG_API;

	return (
		<div>
			{slideSections.length > 0 ? (
				<div className="section-bg-1--- bg-image-top mt-5" style={{ marginBottom: '220px', position: 'relative' }}>
					<div className="overlay-section-shadow" style={{ maxHeight: '410px' }}></div>
					{slideSections.map((section, index) => (
						<div key={index} className="section-bg-1--- bg-image-top p-5"
							style={{ backgroundImage: `url(${img_api + section.background_image})`, backgroundSize: 'cover', backgroundPosition: 'center', maxHeight: '410px' }} >
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className="section-title-area ltn__section-title-2--- text-center---">
											<h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color--- white-color m-0">{section.section_subtitle}</h6>
											<h1 className="section-title white-color mt-3">{section.section_title}</h1>
										</div>
									</div>
								</div>
								<Slider {...downloadFileSettings} className="ltn__upcoming-project-slider-1-active slick-arrow-3" style={{ marginBottom: '-170px' }}>
									{section.slider_images.map((image, imgIndex) => (
										<div className="col-lg-4 col-12 p-0" key={imgIndex}>
											<ImageWithBaseApi className="images-slide" src={image.src} alt={`Slider ${imgIndex + 1}`} />
										</div>
									))}
								</Slider>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className="mb-5"></div>
			)}
		</div>
	);
}

export default UpcomingProductV1;